import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuthContext } from "../../auth-state";
import { ServiceProviderR } from "../pages/service-provider/routes";
import { SettingR } from "../pages/settings/route";
import { LoginR } from "../pages/login/route";

export const AuthedRoute: React.FC<
  {
    component: React.ComponentType<any>;
  } & RouteProps
> = ({ component: Component, ...rest }) => {
  const authAcc = useAuthContext();
  if (!authAcc.lastChecked) {
    return <div />;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!!authAcc.lastChecked && !authAcc.isAuthed) {
          return (
            <Route
              path="/"
              render={() => (
                <Redirect
                  to={LoginR.Login.link({
                    to: `${window.location.pathname}${
                      window.location.search ? "?" + window.location.search : ""
                    }${window.location.hash}`,
                  })}
                />
              )}
            />
          );
        }
        if (authAcc.data!.accountType === "GrafferStaffAccount") {
          return <Redirect to={ServiceProviderR.Home.link({})} />;
        }
        if (
          authAcc.data!.requirePasswordChange &&
          rest.path !== SettingR.ChangePassword.link({})
        ) {
          return (
            <Route
              path="/"
              render={() => <Redirect to={SettingR.ChangePassword.link({})} />}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};
